import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M3 23v-6h2.5v-2H3V9h2.5V7H3V1h7v6H7.5v2H10v2h4V9h7v6h-7v-2h-4v2H7.5v2H10v6Zm2-2h3v-2H5Zm0-8h3v-2H5Zm11 0h3v-2h-3ZM5 5h3V3H5Zm.5-1h1l-1 8h1m11 0Zm-12 8h1\" style=\"transform:scale(.333);transform-origin:13px 15px;\"></path><path d=\"M20.38 20.65H3.62A1.38 1.38 0 0 1 2.41 20a1.4 1.4 0 0 1 0-1.4L10.79 4a1.45 1.45 0 0 1 2.42 0l8.38 14.52a1.4 1.4 0 0 1 0 1.4 1.38 1.38 0 0 1-1.21.73ZM3.8 19.15h16.4L12 5Zm8.29-14.36Z\"></path><g transform=\"translate(9 -5)\"><circle cx=\"12\" cy=\"16.75\" r=\".75\"></circle><path d=\"M12 14.62a.75.75 0 0 1-.75-.75V9.66a.75.75 0 0 1 1.5 0v4.21a.75.75 0 0 1-.75.75Z\"></path></g>", 3)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "NetDiagramOnly"}) } }